import { useRouter } from 'next/router'

import excludeBlankKeys from '@/helpers/excludeBlankKeys'

function usePriceRange(factor = 1) {
  const router = useRouter()

  const { price_from: x, price_to: y } = router.query
  const price_from = Number(x) * factor || null
  const price_to = Number(y) * factor || null

  return excludeBlankKeys<number>({ price_from, price_to })
}

export default usePriceRange
